import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const validationSchema = Yup.object({
  documento: Yup.string().max(100, 'Máximo 100 caracteres'),
  duplica_doc: Yup.string().oneOf(['S', 'N']),
  descricao: Yup.string(),
});

const ModalDocVenda = ({ mostrar, onFechar, onSalvar, documento }) => {
  const isEdicao = documento != null;

  const initialValues = {
    documento: isEdicao ? (documento.documento || '') : '',
    duplica_doc: isEdicao ? (documento.duplica_doc || 'N') : 'N',
    descricao: isEdicao ? (documento.descricao || '') : '',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      documento: values.documento,
      descricao: values.descricao,
      duplica_doc: values.duplica_doc,
    };
    try {
      if (isEdicao) {
        await api.atualizarDocumentoVenda(documento.codigo_doc, payload);
        toast.success('Documento atualizado com sucesso.');
      } else {
        await api.incluirDocumentoVenda(payload);
        toast.success('Documento incluído com sucesso.');
      }
      onSalvar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao processar operação.';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue, handleSubmit: formikSubmit, isSubmitting }) => (
        <Modal show={mostrar} onHide={onFechar} backdrop="static">
          <Modal.Header
            closeButton
            style={{ backgroundColor: '#0747a6', color: '#fff' }}
          >
            <Modal.Title style={{ fontSize: '1rem' }}>
              {isEdicao ? 'Editar Documento' : 'Novo Documento'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={formikSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Documento(s)</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={100}
                  value={values.documento}
                  onChange={(e) => setFieldValue('documento', e.target.value)}
                  isInvalid={touched.documento && !!errors.documento}
                  placeholder="Nome do documento"
                />
                {touched.documento && errors.documento && (
                  <Form.Control.Feedback type="invalid">
                    {errors.documento}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Duplica Documento"
                  checked={values.duplica_doc === 'S'}
                  onChange={(e) => setFieldValue('duplica_doc', e.target.checked ? 'S' : 'N')}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={values.descricao}
                  onChange={(e) => setFieldValue('descricao', e.target.value)}
                  placeholder="Descrição do documento (opcional)"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onFechar} disabled={isSubmitting}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={formikSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Salvar'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
  );
};

export default ModalDocVenda;
